import React from 'react';
import I18n from 'i18n-js';

import buySvg from '../../../images/price-guide-tool/buy.svg';
import sellSvg from '../../../images/price-guide-tool/sell.svg';
import trendsSvg from '../../../images/price-guide-tool/trends.svg';

function PriceGuideToolUse({ image, title, description, altText }) {
  return (
    <div className="price-guide-tool-usage__row__item">
      <div className="price-guide-tool-usage_row_item_image-container">
        <img
          src={image}
          alt={altText}
        />
      </div>
      <div className="price-guide-tool-usage__row__item__content">
        <h5 className="text-title-500 mb-2">
          {title}
        </h5>
        <p className="text-default-400 mb-0">
          {description}
        </p>
      </div>
    </div>
  );
}

export default function PriceGuideToolUsage() {
  return (
    <div className="price-guide-tool-usage">
      <h2 className="price-guide-tool-usage__title">
        {I18n.t('discovery.priceGuideTool.wrapper.usage.title')}
      </h2>
      <div className="price-guide-tool-usage__row">
        <PriceGuideToolUse
          title={I18n.t('discovery.priceGuideTool.wrapper.usage.sell.title')}
          description={I18n.t('discovery.priceGuideTool.wrapper.usage.sell.description')}
          image={sellSvg}
          altText={I18n.t('discovery.priceGuideTool.wrapper.usage.sell.altText')}
        />
        <PriceGuideToolUse
          title={I18n.t('discovery.priceGuideTool.wrapper.usage.buy.title')}
          description={I18n.t('discovery.priceGuideTool.wrapper.usage.buy.description')}
          image={buySvg}
          altText={I18n.t('discovery.priceGuideTool.wrapper.usage.buy.altText')}
        />
        <PriceGuideToolUse
          title={I18n.t('discovery.priceGuideTool.wrapper.usage.trends.title')}
          description={I18n.t('discovery.priceGuideTool.wrapper.usage.trends.description')}
          image={trendsSvg}
          altText={I18n.t('discovery.priceGuideTool.wrapper.usage.trends.altText')}
        />
      </div>
    </div>
  );
}
